import Feed from "../components/Feed";
import Layout from "../components/Layout";
import { useTranslation } from "../hooks/useTranslation";

const FeedPage = () => {
  const { t } = useTranslation();
  const siteUrl = import.meta.env?.VITE_SITE_URL || "https://lenz3.com";

  return (
    <Layout
      title={t("hub.feedPageTitle")}
      description={t("hub.feedPageDescription")}
      canonical={`${siteUrl}/feed`}
    >
      <div className="mx-auto w-full max-w-lg">
        <Feed />
      </div>
    </Layout>
  );
};

export default FeedPage;
